import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import moment from 'moment';
import { NgScrollbarModule } from 'ngx-scrollbar';
import Swal from 'sweetalert2';
import { MaterialModule } from '../../../material.module';
import { AuthService } from '../../../services/auth.service';
import { LoginComponent } from '../../auth/Pages/login/login.component';
import { LicenceComponent } from '../../licence/licence.component';
import { MatDialog } from '@angular/material/dialog';
import { CharityDataShareServiceService } from '../../charity/charities/services/charity-data-share-service.service';
import { LocalStorageService } from '../../../Shared/common/local-storage.service';
import { LoginapiService } from '../../auth/Pages/services/loginapi.service';
import { LicenceDataShareService } from '../../../Shared/common/licence-data-share.service';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { UserLicenseDetailsModel } from '../../../Data/Models/Users/user-license-details-model';
import { UsersApiService } from '../../../Shared/common/users-api.service';
@Component({
  selector: 'app-landingPage',
  imports: [
    MaterialModule,
    TablerIconsModule,
    MatNativeDateModule,
    NgScrollbarModule,
    CommonModule    
  ],
  templateUrl: './landingPage.component.html',
  styleUrl: './landingPage.component.scss'
})
  
export class landingPageComponent implements OnInit {
  isLicenceExpired: boolean = false;
  centralUserID: any;
  currentUserExpiredate:any
  currentUser: any;
  IsAdmin: boolean = false;
  constructor(private userAPIService: UsersApiService,private authService: AuthService, private router: Router, public dialog: MatDialog, private dataShareService: CharityDataShareServiceService, private localStorageService: LocalStorageService, private loginService: LoginapiService, private licenceservice: LicenceDataShareService) {

  }
  ngOnInit() {
    debugger
    var checkuser = localStorage.getItem("UserRecords");
    if (checkuser == '0') {
      //alert(localStorage.getItem("UserRecords"))
      document.body.classList.add('norecords');
    }
    this.currentUserExpiredate = localStorage.getItem('isLicenceExpireddate');
    this.getUserLicenceDetails();
    //this.LicenceExpiredpopup()
    //this.LicenceRenewpopup();
    //this.navigatetocharity()
   
  }
  getUserLicenceDetails() {
    debugger
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.currentUser = parsedUser.userID;
    }

    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      if (data.entity != null) {
        this.IsAdmin = data.entity[0].isAdmin;
        this.LicenceExpiredpopup();
        this.LicenceRenewpopup();
      }
    })
  }
  addCharity() {
    debugger
    if (localStorage.getItem('isLicenceExpired') == 'true') {
      this.LicenceExpiredpopup();
    } else {
      const currentPath = this.router.url
      if (currentPath == "/landingpage") {
        localStorage.setItem("IsFromLandingPage", "true");
        //this.router.navigate(['charity'], { queryParams: { autoRun: true } });
        this.router.navigate(['charity']);
      }
      else {
        this.router.navigate(['charity']);
      }
    }
  }
  LicenceExpiredpopup() {
    if (localStorage.getItem('isLicenceExpired') == 'true') {
      const message = "Andica Charity Accounts Software licence has been expired on "
        + this.currentUserExpiredate + ". ";
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Licence Expired!</h5>  <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">' + message + '</p>',

        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: "Renew",
        reverseButtons: true,
        didOpen: () => {
          setTimeout(() => {
            const confirmBtn = Swal.getConfirmButton();
            if (confirmBtn && !this.IsAdmin) {
              confirmBtn.disabled = true; // Disable the "Renew" button
              confirmBtn.style.opacity = "0.6"; // Optional: visual feedback
              confirmBtn.style.cursor = "not-allowed"; // Optional: cursor style
            }
          }, 100);
        },
        preConfirm: () => {
          this.licenceservice.Upgrade('Renew')
          return false;
        }
      });// Call the validation method if allowed
    }
  
  }
  LicenceRenewpopup() {
   // var diffDays = (moment(this.currentUserExpiredate, "DD/MM/YYYY").diff(moment(), "days"))
    var today = new Date();
    var today1 = moment(today, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
    var diffDays = (moment(this.currentUserExpiredate, "DD/MM/YYYY").diff(moment(today1, "DD/MM/YYYY"), "days"))

    if (diffDays <= 30 && this.dataShareService.canValidate() && diffDays >= 0) {
      const message = "Andica Charity Accounts Software licence is about to expire on "
        + this.currentUserExpiredate + ". ";
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Licence Expiring Soon!</h5>  <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">' + message + '</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Renew",
        reverseButtons: true,
        didOpen: () => {
          setTimeout(() => {
            const confirmBtn = Swal.getConfirmButton();
            if (confirmBtn && !this.IsAdmin) {
              confirmBtn.disabled = true; // Disable the "Renew" button
              confirmBtn.style.opacity = "0.6"; // Optional: visual feedback
              confirmBtn.style.cursor = "not-allowed"; // Optional: cursor style
            }
          }, 100);
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.licenceservice.Upgrade('Renew');
        }
        else {
          this.dataShareService.setRenewpopup('true')
        }
      });
    }
  }




  //licenceValidations(flag: string): void {
  //  debugger
  //  setTimeout(() => {
      
  //  }, 2000, true);
  //  this.authService.checkUserLicenseDetails()
  //  const licenceDetails = this.authService.currentUserLicenseDetailsValue;
  //  if (licenceDetails && moment(licenceDetails.tuEndDate).diff(new Date(), 'days') <= 30 && flag === 'open') {
  //    const todayExact = moment().format("DD/MM/YYYY HH:mm:ss");
  //    const licenseEndDate = moment(licenceDetails.tuEndDate).format("DD/MM/YYYY HH:mm:ss");
  //    const ms = moment(licenseEndDate, "DD/MM/YYYY HH:mm:ss").diff(moment(todayExact, "DD/MM/YYYY HH:mm:ss"));

  //    if (ms <= 0) {
  //      this.isLicenceExpired = true;
  //      localStorage.setItem("isLicenceExpired", "true");
  //      const message = "Andica Charity Accounts Software licence has expired on "
  //        + moment(licenceDetails.tuEndDate).format("DD/MM/YYYY") + ". ";


  //      Swal.fire({
  //        title: "Andica Charity Accounts",
  //        text: message,
  //        icon: "warning",
  //        allowOutsideClick: false,
  //        showCancelButton: false,
  //        confirmButtonText: "Renew"
  //      }).then((result) => {
  //        if (result.isConfirmed) {
  //          this.dialog.open(LicenceComponent, { width: '60%', maxWidth: '100%', disableClose: true });
  //        }
  //      });
  //    } else {
  //      this.isLicenceExpired = false;
  //      localStorage.setItem("isLicenceExpired", "false");
        
  //    }
  //    // Mark validation done and hide popup
  //   this.dataShareService.markValidated();
  //  }
  //}




  checkRenew() {
    debugger
    const storedValue = sessionStorage.getItem('id_token_claims_obj');
    if (storedValue) {
      var email = JSON.parse(storedValue);
    }
    if (email) {
      var email = email.emails[0]
    }
    this.authService.logIn(email)
      .subscribe((res) => {
        debugger
        if (res.status == 0) {
          //Navigate to to the page based on returnUrl
          if (res.entity != null) {
            this.localStorageService.setCurrentUser(res.entity[0]);
            this.authService.currentUserSubject.next(res.entity[0]);
            this.authService.checkUserLicenseDetails();
            // this.dataShareService.setShowExpirePopup(true);
            localStorage.setItem("CurrentuserID", res.entity[0].userID.toString());
            const currentUser = localStorage.getItem('currentUser');
            if (currentUser) {
              const parsedUser = JSON.parse(currentUser);
              this.centralUserID = parsedUser.centralUserID;
            }
          }

        }
      })
  }
 
  
}
